// extracted by mini-css-extract-plugin
export default {"home":"Home_home__sAY0w","mainContent":"Home_mainContent__0GPiu"};